<template>
    <title-bar>
          Replace me
    </title-bar>
</template>

<script>
import TitleBar             from '@/components/TitleBar'
import TrTitleBar           from '@/components/translation/TrTitleBar'
import TrCategory           from "@/components/catalog/TrCategory"
import TrObject             from "@/components/catalog/TrObject"
import TrEdit               from "@/components/translation/TrEdit"
import TrText               from "@/components/translation/TrText"
import MenuVert                 from '@/components/MenuVert'
import { mapState }         from 'vuex'

export default {
    name: "TranslationBaseView",
    components: {
        TrTitleBar, TitleBar, TrCategory, TrObject, TrEdit, TrText, MenuVert
    },
    data () {
        return {tracker: [], currentTrackerIdx: null, isLoading: true}
    },
    computed: {
        ...mapState("translation", { catalogs: state => state.catalogs}),
        uniqueTrUnits () {
            let tids = new Set ()
            let result = []
            this.tracker.forEach(t => {
                if (!tids.has (t.tid)) {
                    tids.add (t.tid)
                    result.push (t)
                }
            })
            return result
        },
        totalTrUnits() {
            return this.uniqueTrUnits.length
        },
        translatedTrUnits() {
            return this.uniqueTrUnits.filter ((tru) => tru.translated).length
        }
    },
    methods : {
        updateRoot (params) {
            this._updateRoot (params)
        },
        clearRoot () {
            this.tracker = []
            this._clearRoot ()
        },
        editTranslation ({tid, trackerIdx}) {
            if (this.currentTrackerIdx !== null) {
                this.tracker [this.currentTrackerIdx].isActive = false
            }
            this.currentTid        = tid
            this.currentTrackerIdx = trackerIdx
            this.tracker [trackerIdx].isActive = true
            this.$scrollTo ("#tracker" + trackerIdx, 100, {offset : -160})
        },
        selectTr({direction, untranslated}) {
            let start   = this.currentTrackerIdx
            let newIdx  = start
            let tracker = null
            do {
                const maxIdx = this.tracker.length - 1
                newIdx = newIdx + direction
                if (newIdx <  0    ) newIdx = maxIdx
                if (newIdx > maxIdx) newIdx = 0
                tracker = this.tracker [newIdx]
                if (!untranslated || !tracker.translated) break
            } while (start != newIdx)
            this.editTranslation ({tid: tracker.tid, trackerIdx: newIdx})
        },
        closeTrEdit () {
            let tracker = this.tracker [this.currentTrackerIdx]
            if (tracker) tracker.isActive = false
            this.currentTrackerIdx = this.currentTid = null
        },
    },
    beforeRouteUpdate (to, from, next) {
        console.log ("Before Route update")
        this.updateRoot (to.params)
        next ()
    },
    beforeRouteLeave (to, from, next) {
        console.log ("Before Route Leave")
        this.clearRoot ()
        next ()
    },
}
</script>